module.exports = __webpack_public_path__ + "img/0.ad30e638.webp";